import { render, staticRenderFns } from "./AddNewDialog.vue?vue&type=template&id=87d8da7c"
import script from "./AddNewDialog.vue?vue&type=script&lang=js"
export * from "./AddNewDialog.vue?vue&type=script&lang=js"
import style0 from "./AddNewDialog.vue?vue&type=style&index=0&id=87d8da7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports